import { GTMCrmSegment, GTMShipmentCategory } from '../types/gtm.js';

const getCrmSegment = numberOfBuys => {
  if (numberOfBuys === 0) {
    return GTMCrmSegment.NEVER_BUYER;
  } else if (numberOfBuys === 1) {
    return GTMCrmSegment.FIRST_TIME_BUYER;
  } else {
    return GTMCrmSegment.RETURNING_BUYER;
  }
};
const getShipmentCategory = (customs, fromAlpha2Code, toAlpha2Code) => {
  if (customs) {
    return GTMShipmentCategory.CONTINENTAL;
  }
  return fromAlpha2Code === toAlpha2Code ? GTMShipmentCategory.NATIONAL : GTMShipmentCategory.INTERNATIONAL;
};
async function hashString(stringValue) {
  if (crypto && crypto.subtle) {
    const msgUint8 = new TextEncoder().encode(stringValue.toLowerCase().trim());
    const hashBuffer = await crypto.subtle.digest('SHA-256', msgUint8);
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    const hashHexString = hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
    return hashHexString;
  }
  return '';
}

/**
 *
 * Hashes email for Google Ads enhanced conversions.
 * Based on https://developers.google.com/google-ads/api/docs/conversions/enhance-conversions#normalization_and_hashing
 *
 */
function getHashedEmail(email) {
  const [emailPrefix, emailDomain] = email.split('@');
  const googleMailRegExp = new RegExp('^(gmail|googlemail)\\.com\\s*');
  const isGmail = emailDomain && googleMailRegExp.test(emailDomain);
  const normalizedEmailPrefix = isGmail ? emailPrefix.replaceAll('.', '') : emailPrefix;
  return hashString([normalizedEmailPrefix, emailDomain].join('@'));
}

export { getCrmSegment, getHashedEmail, getShipmentCategory };
//# sourceMappingURL=gtmUtils.js.map
